import { ConsultationNoteTemplatesTable } from "features/templates/consultation";

export { ConsultationNoteTemplatesTable };

export const ConsultationNoteTemplatesPage = () => {
  return <ConsultationNoteTemplatesTable />;
};
